import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";
import * as moment from 'moment-timezone';

import dictionary from "dict/static.json";

@Component({
	templateUrl: './promocode_info.component.html'
})
export class PromocodeInfoComponent extends InfoModalComponent {
	public moment = moment;
	
	detailLoader: boolean = false;
	details;
	
	get currencyList() { return dictionary.currencyList }
	
	ok() {
		this.close();
	}
}
